import { animated, config, useSpring } from '@react-spring/web';
import { memo } from 'react';

import { CircleAlertIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { type FileStatusIconSize, fileStatusIcon, getFileStatusIconGlyphSize } from '../fileStatusIconSize';

export type FileStatusIconStoppedProps = {
  size?: FileStatusIconSize;
};

export const FileStatusIconStopped = memo(({ size = 'default' }: FileStatusIconStoppedProps) => {
  const { container } = fileStatusIcon({ size });
  const glyphSize = getFileStatusIconGlyphSize(size);
  const [props] = useSpring(
    () => ({
      config: config.wobbly,
      from: { scale: 0 },
      to: { scale: 1 },
    }),
    [],
  );

  return (
    <div
      aria-hidden
      className={cn('flex items-center justify-center rounded-full ads:bg-warning bg-yellow-3', container())}
    >
      <animated.div className="flex items-center justify-center" style={props}>
        <CircleAlertIcon className="ads:text-icon-warning text-yellow-9" size={glyphSize} />
      </animated.div>
    </div>
  );
});

FileStatusIconStopped.displayName = 'FileStatusIconStopped';
